import React, { useEffect, useRef, useState, useCallback } from 'react'
import { BsFillEmojiSmileFill } from 'react-icons/bs'
import Picker, { IEmojiData, IEmojiPickerProps } from 'emoji-picker-react'
import Input, { iInput } from '../Input/Input'

import * as S from './EmojiStyle'

interface iInputEmoji{
    id: string;
    name?: string;
    placeholder?: string;
    notAutoComplete?: boolean;
    disabled?: boolean;
    value?: string | any;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onEmojiClickHandler?: (event: React.MouseEvent<Element, MouseEvent>, data: IEmojiData) => void;
    refInput?: React.RefObject<HTMLInputElement>;
}

const InputEmoji: React.FC<iInputEmoji> = (props) => {

    const {id, name, notAutoComplete, onChange, placeholder, onEmojiClickHandler, value, refInput, disabled } = props
    const wrapperSelectEmojis = useRef<null | HTMLElement>(null)
    const [showEmojiPicker, setShowEmojiPicker] = useState(false)

    const onToggleEmojiPickerHandler = () => {
        return setShowEmojiPicker(prevState => !prevState)
    }

    const onClickOutEmojiPicker = useCallback((event: MouseEvent) => {
        setShowEmojiPicker(() => {
            if (wrapperSelectEmojis.current?.contains(event.target as HTMLInputElement)) {
                return true
            } else {
                return false
            }
        })
    }, [])

    useEffect(() => {
        if (showEmojiPicker) {
            window.addEventListener('click', onClickOutEmojiPicker)
        } else {
            window.removeEventListener('click', onClickOutEmojiPicker)
        }

        return () => window.removeEventListener('click', onClickOutEmojiPicker)
    }, [onClickOutEmojiPicker, showEmojiPicker])

    const inputProps: iInput = {
        id,
        name,
        type: "text",
        placeholder,
        value,
        onChange,
        notAutoComplete,
        disabled,
        refInput
    }

    const pickerProps: IEmojiPickerProps = {
        onEmojiClick: onEmojiClickHandler ? (event, data) => {
                onEmojiClickHandler(event, data); 
                onToggleEmojiPickerHandler();
            } : () => null
    }      
    
    return (
        <S.InputEmojiContainer>
            <Input {...inputProps}/>
            <button type='button' onClick={onToggleEmojiPickerHandler}> <BsFillEmojiSmileFill /> </button>
            {
                showEmojiPicker ?
                    <S.EmojiPickerWrapper ref={wrapperSelectEmojis as any}>
                        <Picker {...pickerProps} />
                    </S.EmojiPickerWrapper>
                    : null
            }
        </S.InputEmojiContainer>
    )

}

export default InputEmoji